import React, { FC, useMemo } from 'react'
import { Gateway, Project } from 'src/api'
import { ProjectList } from '../project/projectList'
import ProjectColumns from '../../columns/project'

interface GatewayPastProjectsProps {
  gateway: Gateway
  noResultText?: string
  showFooter?: boolean
}

const projectColumns = [ProjectColumns.Name, ProjectColumns.Location, ProjectColumns.ContractorName]

export const GatewayPastProjects: FC<GatewayPastProjectsProps> = ({ gateway, noResultText, showFooter = false }) => {
  const projects = useMemo(() => {
    if (!gateway.gatewayProjects) return []
    const uniqueProjectsMap = new Map<number, typeof gateway.gatewayProjects[0]['project']>()
    gateway.gatewayProjects
      .filter((gp) => !gp.isActive && gp.project)
      .sort((a, b) => (a.project?.name || '').localeCompare(b.project?.name || ''))
      .forEach((gp) => {
        if (gp.project && gp.project.id != null && !uniqueProjectsMap.has(gp.project.id)) {
          uniqueProjectsMap.set(gp.project.id, gp.project)
        }
      })
    return Array.from(uniqueProjectsMap.values())
  }, [gateway])

  return <ProjectList data={projects as Project[]} count={projects.length} noResultText={noResultText} showFooter={showFooter} columns={projectColumns} />
}
